<template>
    <div id='PageFooter' class='row'>
        <div class='col-11'>
            <div id='LinkContainer' class='row'>
                <div id='left-link' class='col-4'>
                    <div id='ModuleLinks' class='row'  v-if="isModule == true" :key='uidx'>
                        <ModuleNavLink 
                            v-for='(cardMenuItem, idx) in moduleNavItems'
                            :key='idx'
                            :name='cardMenuItem.name'
                            :linktype='cardMenuItem.link'
                        />
                    </div>
                </div>
                <div id='MoreLinks' class='col-1' v-if="pageType == 'BuyTracker'">
                    <ThreeDotsVerticalIcon />
                </div>
                <div id='SavedTabs' class='col-5'>
                    <div class='row' :key='uidx' v-if="pageType == 'ItemCard'">
                        <SavedProducts
                            :class='savedTabWidth'
                            v-for='(product, idx) in savedProducts'
                            :key='idx'
                            :product='product'
                        />
                    </div>
                    <div class='row' :key='uidx' v-if="pageType == 'BuyTracker'">
                        <SavedBuildTabs
                            :class='savedFormsWidth'
                            v-for='(product, idx) in savedCreators'
                            :key='idx'
                            :product='product'
                        />
                    </div>
                </div>
                <div id='right-link' class='col-2'>
                    <div class='row'>
                        <UtilityLink 
                            v-for='(utility, idx) in utilities'
                            :key='idx'
                            :name='utility.name'
                        />
                    </div>
                </div>
            </div>
            <div id="LinkBottom" class="row">
                <span class="col-12">&nbsp;</span>
            </div>
        </div>
    </div>
</template>


<script>
    import ModuleNavLink from './ModuleNavLink.vue';
    import UtilityLink from './UtilityLink.vue';
    import SavedProducts from './SavedProducts.vue';
    import SavedBuildTabs from './SavedBuildTabs.vue';
    import ThreeDotsVerticalIcon from '../../../icons/ThreeDotsVerticalIcon'
    export default {
        name: 'PageFooter',
        components: {
            ModuleNavLink,
            UtilityLink,
            SavedProducts,
            SavedBuildTabs,
            ThreeDotsVerticalIcon
        },
        data() {
            return {
                utilities: [{name:'SKU Collector'}],
                uidx: 0
            }
        },
        created(){
            this.checkSubComponents();
        },
        computed:{
            isModule(){
                //console.log('isModule called');
                return this.moduleNavItems.length > 0 ? true : false;
            },
            moduleNavItems(){
                //console.log('moduleNavItems called');
                return this.$store.getters['Navigation/moduleNavItems']
            },
            pageType(){
                //return this.$route.meta.activeSubModule || this.$route.name
                return this.$route.meta.activeModule || this.$route.name
            },
            subcomponents(){
                return this.$route.meta.subModules ? this.$route.meta.subModules : []
            },
            isActiveSubModule(){
                return this.$route.meta.activeSubModule ? true : false
            },
            savedProducts(){
                return this.$store.getters['ProductCollection/productCollection']
            },
            savedCreators(){
                return this.$store.getters['ProductCollection/createdCollection']
            },
            savedTabWidth(){
                return 'col-'+ Math.floor(12/this.savedProducts.length);
            },
            savedFormsWidth(){
                return 'col-'+ Math.floor(12/this.savedCreators.length);
            }
        },
        methods: {
            checkSubComponents(){
                //console.log('checksubcomponents - '+ this.subcomponents)
                this.$store.commit('Navigation/setModuleNavs', this.subcomponents)
                this.uidx += 1;
            }
        },
        watch:{
             moduleNavItems(newmoduleNavItems, oldmoduleNavItems){
                if(newmoduleNavItems != {}){
                    //console.log('changed - isModule' + Object.entries(newmoduleNavItems))
                    this.uidx += 1;
                }

            },
            subcomponents(newsubcomponents, oldsubcomponents){
                if(newsubcomponents || this.isActiveSubModule){
                    this.$store.commit('Navigation/setModuleNavs', newsubcomponents)
                }else{
                    if(!this.isActiveSubModule){
                        this.$store.commit('Navigation/setModuleNavs', [])
                    }
                }
                this.uidx += 1;
            },
            savedProducts(newsavedProducts, oldsavedProducts){
                //console.log("do I get here - savedProducts?")
                this.uidx += 1;
            },
            savedCreators(newsavedCreators, oldsavedCreators){
                //console.log("do I get here - savedProducts?")
                this.uidx += 1;
            }
        }
    }
</script>
